import axiosConfig from "./axiosConfig";

class InscriptionService {
  async getAll() {
    try {
      const response = await axiosConfig.get("/inscription");
      return response.data || [];
    } catch (error) {
      console.error("Error fetching inscriptions:", error);
      return [];
    }
  }

  async getById(id) {
    try {
      const response = await axiosConfig.get(`/inscription/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching inscription with ID ${id}:`, error);
      throw error;
    }
  }

  // Pour une réinscription (étudiant existant)
  async create(formData) {
    try {
      const response = await axiosConfig.post("/inscription", formData);
      return response.data;
    } catch (error) {
      console.error(
        "❌ Error creating inscription:",
        error.response?.data || error.message
      );
      return Promise.reject(error.response?.data || { message: error.message });
    }
  }

  // Pour une nouvelle inscription (nouvel étudiant)
  async createWithMembre(formData) {
    try {
      const response = await axiosConfig.post(
        "/inscription/withMembre",
        formData
      );
      return response.data;
    } catch (error) {
      console.error(
        "❌ Error creating inscription with new member:",
        error.response?.data || error.message
      );
      return Promise.reject(error.response?.data || { message: error.message });
    }
  }

  async update(id, formData) {
    try {
      const response = await axiosConfig.put(`/inscription/${id}`, formData);
      return response.data;
    } catch (error) {
      console.error(
        `❌ Error updating inscription with ID ${id}:`,
        error.response?.data || error.message
      );
      return Promise.reject(error.response?.data || { message: error.message });
    }
  }

  async delete(id) {
    try {
      const response = await axiosConfig.delete(`/inscription/${id}`);
      return response.data;
    } catch (error) {
      console.error(
        `❌ Error deleting inscription with ID ${id}:`,
        error.response?.data || error.message
      );
      return Promise.reject(error.response?.data || { message: error.message });
    }
  }
}

const InscriptionServiceInstance = new InscriptionService();
export default InscriptionServiceInstance;
